import { IUser } from '../../models/IUser';
import {uiTokens} from '../common/layout/designTokens';

export const useStyles = (user: IUser | undefined) => {
    const menuWrapper = !!user ? {} : { pointerEvents: 'none', opacity: 0.7 };

    const brandLogo = {
        display: 'block',
        width: 'min(11rem, 42vw)',
        height: 'auto',
    };

    const bar = {
        backgroundColor: 'background.paper',
        width: uiTokens.page.containerWidth,
        maxWidth: uiTokens.page.containerMaxWidth,
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)',
        borderRadius: {xs: 0, md: 2},
        overflow: 'hidden',
    };

    const headerWrapper = {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        boxSizing: 'border-box',
        height: '3rem',
        alignItems: 'center',
    };

    const leftSideWrapper = {
        paddingLeft: '5px',
        color: 'rgba(0, 0, 0, 0.54)',
        cursor: 'pointer',
    };

    const rightSideWrapper = {
        display: 'flex',
        color: 'rgba(0, 0, 0, 0.54)',
        alignItems: 'center',
        minWidth: 0,
        gap: {xs: 0.5, sm: 1},
    };

    const nameStyle = {
        fontWeight: 'bold',
        maxWidth: {xs: '34vw', sm: '45vw', md: 'none'},
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    };

    return {
        menuWrapper,
        brandLogo,
        bar,
        headerWrapper,
        leftSideWrapper,
        rightSideWrapper,
        nameStyle,
    };
};
